import React from 'react';
import PrintButtonsV2 from './PrintButtonsV2';
import PrintButtonsV1 from './PrintButtonsV1';
import { DROP, Original, PrintData } from '../common';
import { getDropFromContractAddress } from 'utils/dropsHelpers';
import ConnectedWalletGuard from 'components/ConnectedWalletGuard';
import { ebChainId } from 'utils/config';

interface PrintButtonsProps {
  original: Original;
  userOwnsPrints: boolean;
  printsData: PrintData;
}

const PrintButtons: React.FC<PrintButtonsProps> = ({ original, userOwnsPrints, printsData }) => {
  const drop = getDropFromContractAddress(original.contractAddress);

  return (
    <ConnectedWalletGuard
      networkId={ebChainId}
      width="100%"
      boxShadow="1"
      bg="secondary"
      fontWeight="600"
      borderRadius="10px"
      p="1em"
      fontSize="1"
      margin="0"
    >
      {drop === DROP.enigma ? (
        <PrintButtonsV2
          original={original}
          userOwnsPrints={userOwnsPrints}
          printsData={printsData}
        />
      ) : (
        <PrintButtonsV1
          original={original}
          userOwnsPrints={userOwnsPrints}
          printsData={printsData}
        />
      )}
    </ConnectedWalletGuard>
  );
};

export default PrintButtons;
